import {POPUP, PopupFloating, PopupTooltip} from "back/commons/widgets/popups";
import "back/wsp/views/itemMain"; //on force l'import des tags ItemMain.
import {IInfo} from "lib/commons/infos";
import {IReg, REG} from 'lib/commons/registry';
import {VIEWS} from "lib/commons/views";
import {DOM, JSX} from "lib/commons/xml/dom";
import {InfoCurrentItem, InfoFocusItem, InfoFocusNodeInItem, InfoReqCurrentItem, InfoSrcUriMoved, ITEM} from "lib/wsp/item";
import {JSrcFields, SRC, srcRef, srcUri} from "lib/wsp/src";
import {IWspUiEnv, JWspUriChangeMsg, WSP} from "lib/wsp/wsp";
import {EWspChangesEvts, WspsLivePlace} from "lib/wsp/wspsLive";
import {JLastDatas, LASTDATAS} from "lib/commons/lastDatas";
import {OTabInit, OTabsInit, Tab, Tabs} from "back/commons/widgets/tabs";
import {IItemTypeUiEnv} from "lib/wsp/wspMetaUi";
import {IItemViewer, ISrcMainCtx, SrcMain} from "back/wsp/views/itemMain";
import {IArea} from "lib/commons/areas";
import {ActionBtn, Button, OActionBtnInit, OButtonInit} from "back/commons/widgets/buttons";
import {ACTION, Action, ActionSeparator, IAction} from "lib/commons/actions";
import {IContextMenuActions, IContextMenuActionsPointer} from "back/commons/actionables";
import {BaseElementAsync} from "back/commons/basis";
import {DOMSH} from "lib/commons/xml/domsh";
import {OpenFastFindItem, OpenSearchItems} from "back/wsp/actions/srcActions";
import {Resizer} from "back/commons/widgets/resizer";
import "back/core/zones/webZones";
import {renderAppend} from "lib/commons/utils/htmlLit";
import {SRCDRAWER, SrcDrawer} from "back/wsp/widgets/srcDrawer";

/**
 * Gestionnaire de visualisation des items.
 * Implémentation en onglets principaux + slots à gauche et à droite + fenêtres flottantes.
 */
export class ItemViewerMulti implements IItemViewer {

	reg: IReg<IWspUiEnv>;

	fallbackOpenSrcRef?: (srcRef: srcRef, longdesc: JSrcFields, silent?: boolean) => Promise<true | null>;

	/**
	 * Ensemble des sources actuellement affichées par cet itemViewer
	 * indexées par son srcUri.
	 */
	//srcsByUri: Map<string, SrcHolder> = new Map();

	/**
	 * Ensemble des sources actuellement affichées par cet itemViewer
	 * indexées par son srcId.
	 */
	//srcsById: Map<string, SrcHolder>;

	/** Nombre d'entrées dans la liste chainée des accès à SrcHolder. */
	//accessCount = 0;

	/** Cache des registres<IItemTypeUiEnv> indexés par l'itModel. */
	itemTypesRegs: Map<string, IReg<IItemTypeUiEnv>> = new Map();

	/** Onglets principaux. */
	mainTabs: SrcTabs;

	/** Onglets latéraux gauche. */
	leftTabs: SrcTabs;

	/** Onglets latéraux droit. */
	rightTabs: SrcTabs;

	/** Fenêtres flottantes ouvertes. */
	floatings: PopupFloating[];

	protected onWspUriChange: (msg: JWspUriChangeMsg, from: WspsLivePlace | 'local' | 'server') => void;


	async initViewer(reg: IReg<IWspUiEnv>, mainViewParent: HTMLElement, lastDatas: JLastDatas, select: srcRef): Promise<any> {
		if (this.reg) console.error("ItemViewerMulti already inited");
		this.reg = reg;
		const infoBroker = reg.env.infoBroker;
		if (infoBroker) infoBroker.addConsumer(this);
		if (lastDatas) {
			const mainLD = (lastDatas as JLDItemViewerMulti).main;
			if (mainLD && mainLD.tabs) {
				this._initUi(mainViewParent, await this._buildAreas(mainLD, select, mainViewParent), mainLD);
			} else if (select) {
				this._initUi(mainViewParent, await this._buildAreas(null, select, mainViewParent));
			} else {
				this._initUi(mainViewParent);
			}
			const leftLD = (lastDatas as JLDItemViewerMulti).left;
			if (leftLD && leftLD.tabs) {
				this._initLeftTabs(await this._buildAreas(leftLD, null, mainViewParent), leftLD);
			}
			const rightLD = (lastDatas as JLDItemViewerMulti).right;
			if (rightLD && rightLD.tabs) {
				this._initRightTabs(await this._buildAreas(rightLD, null, mainViewParent), rightLD);
			}
		} else if (select) {
			this._initUi(mainViewParent, await this._buildAreas(null, select, mainViewParent));
		} else {
			this._initUi(mainViewParent);
		}
	}

	protected _initUi(mainViewParent: HTMLElement, mainAreas?: IArea<IItemViewer, SrcMain>[], mainLD?: JLDItemViewerMultiTabs) {
		const root = mainViewParent.appendChild(<wsp-itemviewer-multi/>).attachShadow(DOMSH.SHADOWDOM_INIT);
		this.reg.installSkin("webzone:item", root);
		this.reg.installSkin("wsp-itemviewer-multi", root);
		this.mainTabs = root.appendChild(new SrcTabs().initialize({
			reg: this.reg,
			areasContext: this,
			areas: mainAreas,
			lastDatasKey: 'main',
			lastDatas: mainLD,
			backgroundPanels: this.reg.getSvc<(tabs: Tabs<ItemViewerMulti>) => Promise<HTMLElement>>("ItemViewerMulti.backgroundPanels")
		}));
		this.onWspUriChange = this._onWspUriChange.bind(this);
		this.reg.env.place.eventsMgr.on("wspUriChange", this.onWspUriChange);
	}

	protected _initLeftTabs(leftAreas?: IArea<IItemViewer, SrcMain>[], leftLD?: JLDItemViewerMultiTabs) {
		if (this.leftTabs) return;
		const mainTabs = this.mainTabs;
		this.leftTabs = mainTabs.parentNode.insertBefore(new SrcTabs().initialize({
			reg: this.reg,
			areasContext: this,
			areas: leftAreas,
			lastDatasKey: 'left',
			lastDatas: leftLD
		}), mainTabs);
		mainTabs.parentNode.insertBefore(<Resizer c-orient="row"/>, mainTabs);
		if (!this.leftTabs._tabs.firstElementChild) this.hideTabs(this.leftTabs);
	}

	protected _initRightTabs(rightAreas?: IArea<IItemViewer, SrcMain>[], rightLD?: JLDItemViewerMultiTabs) {
		if (this.rightTabs) return;
		const mainTabs = this.mainTabs;
		mainTabs.parentNode.appendChild(<Resizer c-orient="row"/>);
		this.rightTabs = mainTabs.parentNode.appendChild(new SrcTabs().initialize({
			reg: this.reg,
			areasContext: this,
			areas: rightAreas,
			lastDatasKey: 'right',
			lastDatas: rightLD
		}));
		if (!this.rightTabs._tabs.firstElementChild) this.hideTabs(this.rightTabs);
	}

	protected async _buildAreas(ldTabs: JLDItemViewerMultiTabs, select: srcRef, uiCtx: HTMLElement): Promise<IArea<IItemViewer, SrcMain>[]> {
		let srcRefs: srcRef[];
		if (select) {
			if (ldTabs) {
				//indépendamment des lastDatas, on impose la sel d'un item via les JWspAppDef (queryString de l'URL)
				ldTabs.tab = select;
				let selectFound: boolean;
				srcRefs = ldTabs.tabs.map((t) => {
					if (select === t.srcRef) selectFound = true;
					return t.srcRef;
				});
				if (!selectFound) {
					//cet item sélectionné par les JWspAppDef n'est pas présent dans les onglets à réafficher.
					//On ajoute un onglet pour afficher 'select'.
					srcRefs.push(select);
					ldTabs.tabs.push({srcRef: select});
				}
			} else {
				//pas de lastDatas, mais un select
				ldTabs = {tabs: [{srcRef: select}]};
				srcRefs = [select];
			}
		} else {
			srcRefs = ldTabs.tabs.map(t => t.srcRef).filter((srcRef) => !SRC.isNewSrcUri(srcRef));
		}
		const srcs = await WSP.fetchShortDescs(this.reg.env.wsp, uiCtx, ...srcRefs);
		const results: SrcArea[] = [];
		let k = 0;
		for (let i = 0, s = ldTabs.tabs.length; i < s; i++) {
			const ldTab = ldTabs.tabs[i];
			const sd = SRC.isNewSrcUri(ldTab.srcRef) ? {srcUri: ldTab.srcRef, itModel: SRC.extractItModelFromNewSrcUri(ldTab.srcRef), srcSt: 1} : srcs[k++];
			if (sd.srcSt > 0 && sd.itModel != null) {
				results.push(new SrcArea(this, sd, null, ldTab).setPinned(ldTab.pin).setShowTime(i));
			}
		}
		return results;
	}

	openSrcRef(srcRef: srcRef, silent?: boolean, lastDatas?: JLastDatas): Promise<boolean | null> {
		return this.openSrcRefInSrcTabs(this.mainTabs, srcRef, silent, lastDatas);
	}

	onInfo(info: IInfo): void {
		if (info instanceof InfoFocusItem) {
			if (info instanceof InfoFocusNodeInItem) {
				this.focusNodeInItem(info);
			} else {
				this.focusItem(info);
			}
			info.handled = true;
		} else if (info instanceof InfoReqCurrentItem) {
			if (this.mainTabs) {
				const tab = this.mainTabs.selectedTab;
				if (tab && tab.view instanceof SrcMain) {
					const longDesc = tab.view.reg.env.longDesc;
					if (longDesc) {
						info.srcUri = longDesc.srcUri;
						info.shortDesc = longDesc;
					}
				}
			}
		} else if (info instanceof InfoSrcUriMoved) {
			this.onSrcMoved(info);
		}
	}

	focusItem(info: InfoFocusItem) {
		this.openSrcRef(info.srcRef, false, info.lastDatas);
	}

	async focusNodeInItem(info: InfoFocusNodeInItem) {
		if (this.isSrcRefShown(this.mainTabs, info.srcRef)) return; //item déjà chargé et affiché en 1er plan, il va gérer la partie "inItem".
		if (await this.openSrcRef(info.srcRef)) {
			//On redispatch la demande une fois l'item chargé.
			const tab = this.mainTabs.selectedTab;
			if (tab.view instanceof BaseElementAsync) await tab.view.initializedAsync;
			this.reg.env.infoBroker.dispatchInfo(new InfoFocusNodeInItem(info.xpath, info.srcRef), this);
		}
	}

	/**
	 * Si l'ancienne uri est présente et la nouvelle uri est absente,
	 * on remplace l'onglet avec la nouvelle uri.
	 */
	async onSrcMoved(info: InfoSrcUriMoved) {
		const tab = !this.mainTabs.getTabBySrcRef(info.newSrcUri) ? this.mainTabs.getTabBySrcRef(info.oldSrcUri) : null;
		const tabLeft = !this.leftTabs?.getTabBySrcRef(info.newSrcUri) ? this.leftTabs?.getTabBySrcRef(info.oldSrcUri) : null;
		const tabRight = !this.leftTabs?.getTabBySrcRef(info.newSrcUri) ? this.rightTabs?.getTabBySrcRef(info.oldSrcUri) : null;
		if (tab || tabLeft || tabRight) {
			const wsp = this.reg.env.wsp;
			const longDesc = await wsp.fetchLongDesc(info.newSrcUri);
			if (longDesc.srcSt < 0 || longDesc.itModel == null) {
				// tab?.closeTabView(true);
				// tabLeft?.closeTabView(true);
				// tabRight?.closeTabView(true);
				return false;
			}
			if (tab && tab.isConnected) await this.mainTabs.replaceTab(tab, new SrcArea(this, longDesc, longDesc));
			if (tabLeft && tabLeft.isConnected) await this.leftTabs.replaceTab(tabLeft, new SrcArea(this, longDesc, longDesc));
			if (tabRight && tabRight.isConnected) await this.leftTabs.replaceTab(tabRight, new SrcArea(this, longDesc, longDesc));
		}
		return true;
	}

	openSrcRefInTabs(tabPos: 'left' | 'main' | 'right', srcRef: srcRef, silent?: boolean): Promise<boolean> {
		switch (tabPos) {
		case 'main':
			return this.openSrcRefInSrcTabs(this.mainTabs, srcRef, silent);
		case 'left':
			if (!this.leftTabs) this._initLeftTabs();
			this.showTabs(this.leftTabs);
			return this.openSrcRefInSrcTabs(this.leftTabs, srcRef, silent);
		case 'right':
			if (!this.rightTabs) this._initRightTabs();
			this.showTabs(this.rightTabs);
			return this.openSrcRefInSrcTabs(this.rightTabs, srcRef, silent);
		}
		throw Error(tabPos);
	}

	isSrcRefShown(tabs: SrcTabs, srcRef: srcRef): boolean {
		const tab = tabs.getTabByCode(srcRef);
		if (tab) return tabs.selectedTab === tab;
		return false;
	}

	async openSrcRefInSrcTabs(tabs: SrcTabs, srcRef: srcRef, silent?: boolean, lastDatas?: JLastDatas): Promise<boolean | null> {
		try {
			const tab = tabs.getTabByCode(srcRef);
			if (tab) return tabs.selectTab(tab);
			const wsp = this.reg.env.wsp;
			const longDesc =
				SRC.isNewSrcUri(srcRef) ?
					//Fake longDesc si contenu en création
					{srcUri: srcRef, itModel: SRC.extractItModelFromNewSrcUri(srcRef), srcSt: 1, srcRoles: this.reg.env.securityCtx.srcRoles} :
					//Fetch longDesc
					await wsp.fetchLongDesc(srcRef);
			if (longDesc.srcSt < 0 || longDesc.itModel == null) {
				if (this.fallbackOpenSrcRef) {
					return this.fallbackOpenSrcRef(srcRef, longDesc, silent);
				} else {
					if (!silent) POPUP.showNotifInfo("Ce contenu n'est plus disponible.", tabs);
					return null;
				}
			}
			await tabs.addTab(new SrcArea(this, longDesc, longDesc, lastDatas), {select: true});
			return true;
		} catch (e) {
			console.trace(e);
			return null;
		}
	}

	getRegItemType(itModel: string) {
		const wsp = this.reg.env.wsp;
		let reg = this.itemTypesRegs.get(itModel);
		if (!reg) {
			const itemType = wsp.wspMetaUi.getItemType(itModel);
			reg = REG.createSubRegMixed(this.reg, itemType.reg);
			this.itemTypesRegs.set(itModel, reg);
		}
		return reg;
	}

	onViewShown() {
		//this.app.reg.env.wsp.
		VIEWS.onViewShown(this.mainTabs);
		if (this.leftTabs) VIEWS.onViewShown(this.leftTabs);
		if (this.rightTabs) VIEWS.onViewShown(this.rightTabs);
		if (this.floatings) throw Error("TODO floatings...");
	}

	onViewHidden(closed?: boolean) {
		if (closed) {
			this.reg.env.place.eventsMgr.removeListener("wspUriChange", this.onWspUriChange);
			VIEWS.onViewHidden(this.mainTabs, true);
			if (this.leftTabs) VIEWS.onViewHidden(this.leftTabs, true);
			if (this.rightTabs) VIEWS.onViewHidden(this.rightTabs, true);
			if (this.floatings) throw Error("TODO floatings...");
		} else {
			VIEWS.onViewHidden(this.mainTabs, false);
			if (this.leftTabs) VIEWS.onViewHidden(this.leftTabs, false);
			if (this.rightTabs) VIEWS.onViewHidden(this.rightTabs, false);
			if (this.floatings) throw Error("TODO floatings...");
		}
	}

	buildLastDatas(parentLastDatas: JLDItemViewerMulti): void {
		//TODO buildLastDatas floatings.
		//Les lastDatas des onglets sont buildés naturellement par l'arbo DOM.
	}

	protected _onWspUriChange(msg: JWspUriChangeMsg, from: WspsLivePlace | 'local' | 'server') {
		if (msg.type === EWspChangesEvts.r) {
			//Traitement du remove
			const type = ITEM.getSrcUriType(msg.srcUri);
			if (type === 'item') {
				//Suppr de l'item
				const srcRef = SRC.srcRef(msg);
				this.mainTabs.closeItem(srcRef);
				if (this.leftTabs) this.leftTabs.closeItem(srcRef);
				if (this.rightTabs) this.rightTabs.closeItem(srcRef);
			} else if (type === 'space') {
				//Suppr d'un espace ancêtre de l'item
				this.mainTabs.closeSpace(msg.srcUri);
				if (this.leftTabs) this.leftTabs.closeSpace(msg.srcUri);
				if (this.rightTabs) this.rightTabs.closeSpace(msg.srcUri);
			}
		} else if (msg.type === EWspChangesEvts.u) {
			//Traitement de l'update
			const srcRef = SRC.srcRef(msg);
			const tab = this.getOneTabForSrcRef(srcRef);
			if (tab && tab.view) {
				//item construit, faut détecter si l'itModel n'a pas été modifié
				const oldItModel = (tab.area as SrcArea).shortDesc.itModel;
				this.reg.env.wsp.fetchLongDesc(srcRef, this.mainTabs).then((ld: JSrcFields) => {
					this.refreshSrc(ld, ld, oldItModel !== ld.itModel);
				});
			} else if (tab) {
				//item dans les onglets, mais non construit
				this.reg.env.wsp.fetchShortDesc(srcRef, this.mainTabs).then((sd: JSrcFields) => {
					this.refreshSrc(sd);
				});
			}
		} else if (msg.type === EWspChangesEvts.s) {
			const srcRef = SRC.srcRef(msg);
			const tab = this.getOneTabForSrcRef(srcRef);
			if (tab) {
				const area = tab.area as SrcArea;
				if (area.longDesc) {
					area.longDesc.itSt = msg.itSt;
					this.refreshSrc(area.longDesc, area.longDesc);
				} else {
					area.shortDesc.itSt = msg.itSt;
					this.refreshSrc(area.shortDesc);
				}
			}
		}
	}

	/** Retourne le 1er tab pour ce srcRef avec view construite, ou à défaut, sans view construite. */
	getOneTabForSrcRef(srcRef: srcRef): SrcTab {
		let tab = this.mainTabs.getTabBySrcRef(srcRef);
		if ((!tab || !tab.view) && this.leftTabs) tab = this.leftTabs.getTabBySrcRef(srcRef);
		if ((!tab || !tab.view) && this.rightTabs) tab = this.rightTabs.getTabBySrcRef(srcRef);
		return tab;
	}

	refreshSrc(shortDesc: JSrcFields, longDesc?: JSrcFields, rebuild?: boolean) {
		const srcRef = SRC.srcRef(shortDesc);
		let tab = this.mainTabs.getTabBySrcRef(srcRef);
		if (tab) rebuild ? tab.rebuildItemView(this, longDesc) : tab.updateSrc(shortDesc, longDesc);
		if (this.leftTabs) {
			tab = this.leftTabs.getTabBySrcRef(srcRef);
			if (tab) rebuild ? tab.rebuildItemView(this, longDesc) : tab.updateSrc(shortDesc, longDesc);
		}
		if (this.rightTabs) {
			tab = this.rightTabs.getTabBySrcRef(srcRef);
			if (tab) rebuild ? tab.rebuildItemView(this, longDesc) : tab.updateSrc(shortDesc, longDesc);
		}
	}

	/** Masque un SrcTabs secondaire. */
	hideTabs(tabs: SrcTabs) {
		if (DOM.setHidden(tabs, true)) {
			if (tabs.tabsPos === 'left') (tabs.nextElementSibling as Resizer).hidden = true;
			else (tabs.previousElementSibling as Resizer).hidden = true;
		}
	}

	/** Vérifie qu'un SrcTabs secondaire est visible. */
	showTabs(tabs: SrcTabs) {
		if (DOM.setHidden(tabs, false)) {
			if (tabs.tabsPos === 'left') (tabs.nextElementSibling as Resizer).hidden = false;
			else (tabs.previousElementSibling as Resizer).hidden = false;
		}
	}
}


REG.reg.registerSkin('wsp-itemviewer-multi', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-width: 0;
		min-height: 0;
		background-color: var(--bgcolor);
		color: var(--color);
	}

	[hidden] {
		display: none;
	}

	c-resizer {
		width: 1px;
	}

	hr {
		border: none;
		border-inline-start: 1px solid var(--border-color);
		margin: .2rem;
		align-self: stretch;
	}
`);


/**
 * Area d'un ItemMain dans le contexte du ItemViewerMulti.
 * Chaque instance d'area est spécifique à chaque src : SrcArea implémente ISrcMainCtx
 * pour servir de context à l'ItemMainArea fournit par l'itemType.
 */
class SrcArea implements IArea<IItemViewer, SrcMain>, ISrcMainCtx {

	reg: IReg<IItemTypeUiEnv>;
	longDesc: JSrcFields;
	shortDesc: JSrcFields;

	pinned: boolean;
	showTime: number;
	lastDatas: JLastDatas;

	protected _id: string;

	/** ItemMainArea issu de l'itemType. */
	protected _subArea: IArea<ISrcMainCtx, SrcMain>;

	constructor(itemViewer: ItemViewerMulti, shortDesc: JSrcFields, longDesc?: JSrcFields, lastDatas?: JLastDatas) {
		this._id = SRC.srcRef(shortDesc);
		this.shortDesc = shortDesc;
		this.longDesc = longDesc;
		if (lastDatas) this.lastDatas = lastDatas;
		this.reg = itemViewer.getRegItemType(shortDesc.itModel);
		this._subArea = this.reg.env.itemType.getSrcMainArea(this);
	}

	setPinned(p: boolean): this {
		this.pinned = p === true;
		return this;
	}

	setShowTime(t: number): this {
		this.showTime = t;
		return this;
	}

	updateSrcAndModel(itemViewer: ItemViewerMulti, ld: JSrcFields) {
		this.shortDesc = ld;
		this.longDesc = ld;
		this.reg = itemViewer.getRegItemType(ld.itModel);
		this._subArea = this.reg.env.itemType.getSrcMainArea(this);
	}

	getId(): string {
		return this._id;
	}

	getLabel(ctx: ItemViewerMulti): string {
		return this._subArea.getLabel(this);
	}

	getIcon(ctx: ItemViewerMulti): string {
		return this._subArea.getIcon(this);
	}

	getDescription(ctx: ItemViewerMulti): string {
		return this._subArea.getDescription(this);
	}

	getGroup(ctx: ItemViewerMulti): string {
		return this._subArea.getGroup(this);
	}

	getLastDatasKey(ctx: ItemViewerMulti): string {
		return this._subArea.getLastDatasKey(this);
	}

	getSkin(ctx: ItemViewerMulti): string {
		return this._subArea.getSkin(this);
	}

	getSkinOver(ctx: ItemViewerMulti): string {
		return this._subArea.getSkinOver(this);
	}

	isAvailable(ctx: ItemViewerMulti): boolean {return true}

	isEnabled(ctx: ItemViewerMulti): boolean {return true}

	isVisible(ctx: ItemViewerMulti): boolean {return true}

	isInstantiable(ctx: IItemViewer): boolean {return true}

	needAsync(ctx: ItemViewerMulti): boolean {
		return this._subArea.needAsync(this);
	}

	loadBody(ctx: ItemViewerMulti, lastDatas?: JLastDatas): Promise<SrcMain> {
		return this._subArea.loadBody(this, lastDatas);
	}

	loadLibs(ctx: IItemViewer): Promise<void> {
		return this._subArea.loadLibs(this);
	}

	buildBody(ctx: ItemViewerMulti, lastDatas?: JLastDatas): SrcMain {
		return this._subArea.buildBody(this, lastDatas);
	}
}

/** LastDatas dédiés. */
interface JLDItemViewerMulti extends JLastDatas {
	main?: JLDItemViewerMultiTabs
	left?: JLDItemViewerMultiTabs
	right?: JLDItemViewerMultiTabs
	floatings?: JLastDatas[]
}

interface JLDItemViewerMultiTabs extends JLastDatas {
	tab?: string
	tabs?: JLDItemViewerMultiTab[]
	histo?: string[]
}

interface JLDItemViewerMultiTab extends JLastDatas {
	srcRef: srcRef
	pin?: boolean
}


/** Regroupement d'onglets dédiés */
export class SrcTabs extends Tabs<ItemViewerMulti> {

	reg: IReg<IWspUiEnv>;

	menuActions: IAction<SrcTab>[];

	histo: Set<srcRef>;

	get tabsPos(): 'left' | 'main' | 'right' {return this.getAttribute('last-datas') as any}

	isMainTabs(): boolean {return this.areasContext.mainTabs === this}

	async selectTab(tab: Tab<ItemViewerMulti>, lastDatas?: JLastDatas): Promise<boolean> {
		if (tab === this._selectedTab) {
			//On force un refocus (scrolls explorateur...)
			const area = tab.area;
			if (area instanceof SrcArea && this.isMainTabs()) {
				//On est dans les onglets principaux et l'onglet affiché est de type item.
				const infoBroker = this.areasContext.reg.env.infoBroker;
				if (infoBroker) infoBroker.dispatchInfo(new InfoCurrentItem(area.shortDesc.srcUri, area.shortDesc), this);
			}
			return true;
		}
		return super.selectTab(tab, lastDatas);
	}

	async closeTab(tab: SrcTab, silently?: boolean): Promise<boolean> {
		if (!await super.closeTab(tab, silently, true)) return false;
		if (!this.isMainTabs() && !this._tabs.firstElementChild) {
			//Tabs secondaires et plus de tabs, on masque
			this.areasContext.hideTabs(this);
		}
		return true;
	}

	getTabBySrcRef(srcRef: srcRef): SrcTab {
		return this.getTabByCode(srcRef) as SrcTab;
	}

	closeItem(srcRef: srcRef) {
		const tab = this.getTabBySrcRef(srcRef);
		if (tab) this.closeTab(tab);
	}

	closeSpace(spaceUri: srcUri) {
		this.visitTabs((t) => {
			const area = t.area;
			if (area instanceof SrcArea) {
				if (SRC.isSubUriOrEqual(spaceUri, area.shortDesc.srcUri)) this.closeTab(t as SrcTab);
			}
		})
	}

	addHisto(srcRef: srcRef) {
		if (this.histo.size > 12) {
			let del = 0;
			for (const s of this.histo) {
				this.histo.delete(s);
				if (++del === 12) break;
			}
		}
		this.histo.add(srcRef);
	}

	remHisto(srcRef: srcRef) {
		this.histo.delete(srcRef);
	}

	getOldestRemovableTabs(): SrcTab[] {
		const result: SrcTab[] = [];
		let tab = this._tabs.firstElementChild;
		while (tab) {
			if (tab instanceof SrcTab && !tab.frozen && !tab.pinned) result.push(tab);
			tab = tab.nextElementSibling;
		}
		result.sort((t1, t2) => t1.showTime - t2.showTime);
		return result; //[this._tabs.firstElementChild as SrcTab]; //TODO
	}

	protected _initialize(init: OTabsInit<ItemViewerMulti>): Promise<void> {
		this._movable = true;
		this._showOnDragOver = true;
		this.classList.add("noBorder");
		this.setAttribute("c-resizable", "");
		this.style.flex = "1";
		init.skin = "c-tabs/wsp-src-tabs";
		init.cbOverflow = async (overflow: boolean) => {
			if (overflow) {
				//Tentavie de cleanup des anciens tabs.
				const oldests = this.getOldestRemovableTabs();
				for (let i = 0, s = oldests.length - 2; i < s; i++) {// -2 : on garde toujours au moins 2 onglets
					const oldest = oldests[i];
					if (oldest.isConnected) {
						await this.closeTab(oldest, true);
						if (!this._tabs.isOverflow) return;
					}
				}
			}
		};
		this.reg = this.findReg(init);

		if (init.lastDatas && (init.lastDatas as JLDItemViewerMultiTabs).histo) this.histo = new Set((init.lastDatas as JLDItemViewerMultiTabs).histo);
		else this.histo = new Set();
		this.append(
			<hr slot="tools-end"/>,
			<Button slot="tools-end" title="Historique des items affichés" î={{
				reg: this.reg,
				icon: "/@skin@/wsp/views/itemViewerMulti/histo.svg"
			} as OButtonInit} onclick={this.onClickHisto}/>,
			<ActionBtn slot="tools-end" î={{
				reg: this.reg,
				action: new OpenFastFindItem(),
				actionContext: this,
				accel: ACTION.getAccelText({mainKey: "<", accelKey: true}),
				uiContext: 'bar'
			} as OActionBtnInit<any>}/>,
			<ActionBtn slot="tools-end" î={{
				reg: this.reg,
				action: new OpenSearchItems(),
				accel: ACTION.getAccelText({mainKey: "F", accelKey: true, shiftKey: true}),
				actionContext: this,
				uiContext: 'bar'
			} as OActionBtnInit<any>}/>
		);

		this.menuActions = ACTION.injectSepByGroup(this.reg.getList<IAction<SrcTab>>("actions:itemViewerMulti"), "tab * close", null);

		this.addEventListener("wsp-need-valid", this.onNeedValid);

		return super._initialize(init);
	}

	_initShadowRoot() {
		//Tabs en bas
		const sr = this.shadowRoot;
		this._tabs.id = 'tabs';
		sr.appendChild(<div id='head'>
			<slot name='tools-start'/>
			{this._tabs}
			<slot name='tools-end'/>
		</div>);
		sr.appendChild(<div id='panels'>{this._mainSlot}</div>);
	};

	_initTabs() {
		if (this._areas) this._areas.forEach((area: IArea<ItemViewerMulti>) => {
			this._newTab(area);
		});
	}

	_newTab(area: IArea<ItemViewerMulti>, before?: Tab<ItemViewerMulti>): SrcTab {
		const tab = new SrcTab().initialize({
			parentViewCtn: this,
			area: area
		});
		this._initTab(tab);
		this._tabs.insertBefore(tab, before);
		return tab;
	}

	buildLastDatas(p: JLDItemViewerMulti) {
		const k = this.getAttribute("last-datas") as 'main' | 'left' | 'right';
		const ld = {} as JLDItemViewerMultiTabs;
		ld.histo = Array.from(this.histo);
		ld.tabs = [] as JLDItemViewerMultiTab[];
		this.visitTabs((t: SrcTab) => {
			if (!t.frozen && t.area instanceof SrcArea) {
				const s = {} as JLDItemViewerMultiTab;
				if (t.selected) {
					ld.tab = t.code;
					LASTDATAS.buildLastDatas(s, t.view, true);
				} else if (t.area.lastDatas) Object.assign(s, t.area.lastDatas);
				s.srcRef = t.area.getId();
				s.pin = t.pinned ? true : undefined;
				ld.tabs.push(s);
			}
		});
		if (this.isMainTabs()) {
			p[k] = ld;
			this.areasContext.buildLastDatas(p);//floating windows
		} else if (ld.tabs.length > 0) {
			//Onglets secondaires renseignés que si non vides.
			p[k] = ld;
		}
	}

	async onClickHisto(this: Button, ev: Event) {
		const target = ev.target as HTMLElement; //avant async
		const tabs = this.parentElement as SrcTabs;
		const actions: IAction<SrcTabs>[] = [];
		if (tabs.histo.size > 0) {
			const wsp = tabs.reg.env.wsp;
			const srcs = await WSP.fetchShortDescs(wsp, tabs, ...tabs.histo);
			for (const src of srcs) {
				if (src && src.srcSt > 0 && src.itModel != null) actions.push(new SrcOpenFromHisto(tabs.areasContext, src));
			}
		}
		if (actions.length === 0) actions.push(new Action<SrcTabs>('none').setEnabled(false).setLabel("Historique vide"));
		else actions.reverse();
		actions.push(
			new ActionSeparator(),
			new OpenFastFindItem().setLabel("Autre item...")
		);
		POPUP.showPopupActionsFromEvent({
			reg: tabs.reg,
			actions,
			actionContext: tabs
		}, ev, target);
	}


	protected onNeedValid(ev: CustomEvent) {
		const tab = this.findTabFromDesc(ev.target as Node) as SrcTab;
		if (tab) tab.needValid = ev.detail as boolean;
	}
}


REG.reg.registerSkin('c-tabs/wsp-src-tabs', 1, /* language=CSS */ `
	#tabs > .selected {
		background-color: var(--page-bgcolor);
	}
`);

customElements.define("wsp-src-tabs", SrcTabs);

/** Onglet d'un item. */
export class SrcTab extends Tab<ItemViewerMulti> implements IContextMenuActionsPointer<SrcTab> {

	parentViewCtn: SrcTabs;

	/** Onglet épinglé par le user. */
	get pinned(): boolean {return this.classList.contains('pinned')};

	set pinned(v: boolean) {this.classList.toggle('pinned', v)};

	/** Onglet dont le contenu attend une action explicite de l'utilisateur de validation. */
	get needValid(): boolean {return this.classList.contains('needValid')};

	set needValid(v: boolean) {this.classList.toggle('needValid', v)};

	/** Onglet figé applicativement. Ne peut être supprimé par le user. */
	frozen: boolean;

	showTime: number;

	_bodyElt: HTMLElement;
	_closeElt: HTMLElement;

	isMainTabs(): boolean {return this.areaContext.mainTabs === this.parentViewCtn}

	/** Ne doit être appelé que par SrcTabs. */
	async closeTabView(silently?: boolean): Promise<boolean> {
		if (this.area instanceof SrcArea) this.parentViewCtn.addHisto(SRC.srcRef(this.area.shortDesc));
		if (!await super.closeTabView(silently)) return false;
		if (this.selected && this.isMainTabs() && this.area instanceof SrcArea) {
			//On est dans les onglets principaux et l'onglet est sel, on dispatch la perte de la sel.
			const infoBroker = this.parentViewCtn.areasContext.reg.env.infoBroker;
			if (infoBroker) infoBroker.dispatchInfo(new InfoCurrentItem(null), this);
		}
		return true;
	}

	async show(lastDatas?: JLastDatas): Promise<void> {
		const area = this.area;
		await super.show(area instanceof SrcArea ? area.lastDatas : lastDatas);
		this.showTime = Date.now();
		if (this.isMainTabs() && area instanceof SrcArea) {
			//On est dans les onglets principaux et l'onglet affiché est de type item.
			const view = this.view as SrcMain;
			if (!view) return;
			await view.initializedAsync;
			area.longDesc = area.shortDesc = view.reg.env.longDesc;
			const infoBroker = this.parentViewCtn.areasContext.reg.env.infoBroker;
			if (infoBroker) infoBroker.dispatchInfo(new InfoCurrentItem(area.shortDesc.srcUri, area.shortDesc), this);
		}
	}

	async hide(willSelect?: Tab<ItemViewerMulti>): Promise<boolean> {
		if (this.area instanceof SrcArea) this.area.lastDatas = LASTDATAS.buildLastDatas({}, this.view, true);
		const hidden = await super.hide();
		if (hidden && willSelect == null && this.isMainTabs() && this.area instanceof SrcArea && this.area.longDesc) {
			//Pas de nouvel onglet à afficher (si willSelect non null, 2 events successifs et problème avec l'historique du navigateur)
			//On est dans les onglets principaux et l'onglet affiché est de type item.
			//=> on dispatch l'absence d'onglet sélectionné
			const infoBroker = this.parentViewCtn.areasContext.reg.env.infoBroker;
			if (infoBroker) infoBroker.dispatchInfo(new InfoCurrentItem(null), this);
		}
		return hidden;
	}

	updateSrc(shortDesc: JSrcFields, longDesc?: JSrcFields) {
		if (this.area instanceof SrcArea) {
			this.area.shortDesc = shortDesc;
			this.area.longDesc = longDesc;
			this.refresh();
		}
	}

	async rebuildItemView(itemViewer: ItemViewerMulti, longDesc: JSrcFields) {
		if (this.area instanceof SrcArea) {
			this.area.updateSrcAndModel(itemViewer, longDesc);
			const wasShown = this._shown;
			this._shown = false;
			this.needValid = false;
			await super.closeTabView(true);
			if (wasShown) super.show(this.area.lastDatas);
			else this.refresh();
		}
	}

	get ctxMenuActions(): IContextMenuActions<SrcTab> {
		return {
			actions: this.parentViewCtn.menuActions,
			actionContext: this
		}
	}

	protected _initialize(init: OTabInit<ItemViewerMulti>) {
		if (!init.skin) init.skin = "wsp-src-tab";
		super._initialize(init);
		this._bodyElt = this.shadowRoot.appendChild(<div/>);
		this._iconElt = this._bodyElt.appendChild(<span class='icon'/>);
		this._labelElt = this._bodyElt.appendChild(<span class='label'/>);
		this.addEventListener("pointerover", this.onPointerOver); //btn close
		if (init.area instanceof SrcArea) {
			this.parentViewCtn.remHisto(SRC.srcRef(init.area.shortDesc));
			this.pinned = init.area.pinned === true;
			this.showTime = init.area.showTime;
			this.setAttribute("draggable", "true");
			this.addEventListener("dragstart", this._onDragStart);
			this.addEventListener('dragend', ITEM.resetShortDescTransferToDragSession);
			this.addEventListener('pointerenter', function (this: SrcTab, ev) {
				const tt = new PopupTooltip().initialize({
					tooltipOf: this,
					hoverAllowed: true
				});
				tt.addEventListener('c-show', function (this: PopupTooltip, ev) {
					const srcArea = (this.tooltipOf as SrcTab).area as SrcArea;
					const drawer = this.view as SrcDrawer || this.appendChild(new SrcDrawer().initialize({skin: 'wsp-src-drawer/tooltip', tpl: SRCDRAWER.detailsTpl, reg: srcArea.reg}));
					const itemType = srcArea.reg.env.itemType;
					const tpl = itemType ? SRCDRAWER.detailsTpl(itemType, srcArea.shortDesc, drawer) : null;
					if (tpl) renderAppend(tpl, drawer.shadowRoot);
					else this.close();
				});
				tt.forwardPointerEnter(ev);
			}, {once: true});
		} else {
			this.pinned = false;
			this.showTime = 0;
		}
		this.frozen = false;
	}

	protected _onDragStart(ev: DragEvent) {
		if (this.area instanceof SrcArea) {
			ITEM.setShortDescTransferToDragSession({
				reg: this.area.reg,
				infoBroker: this.area.reg.env.infoBroker,
				shortDescs: [this.area.shortDesc],
				emitter: this
			}, ev, 'build');
		}
	}

	/** Affichage du bouton close. */
	protected onPointerOver(ev: PointerEvent) {
		if (!this._closeElt) {
			this.addEventListener("pointerout", this.onPointerOut);
			this._closeElt = this.shadowRoot.appendChild(<ActionBtn id="close" î={{
				action: closeAction,
				actionContext: this,
				uiContext: 'bar'
			} as OActionBtnInit<SrcTab>}/>);
			this._closeElt.onpointerdown = (ev: Event) => {ev.stopPropagation()}//bloque le click et le drag du tab.
		} else {
			DOM.setHidden(this._closeElt, false);
		}
	}

	/** Masquage du bouton close. */
	protected onPointerOut(ev: PointerEvent) {
		if (this._closeElt) DOM.setHidden(this._closeElt, true);
	}

}

REG.reg.registerSkin('wsp-src-tab', 1, /* language=CSS */ `
	:host {
		display: flex;
		min-width: min-content !important;
		user-select: none;
		cursor: pointer;
	}

	:host(.pinned) > div {
		background: url("/@skin@/wsp/views/itemViewerMulti/pin.svg") no-repeat top 2px right;
		background-size: .7em;
		padding-inline-end: .7em !important;
	}

	:host(.needValid) {
		font-weight: bold;
	}

	:host(.needValid) > * > .label::after {
		font-weight: bold;
		content: "*";
		color: var(--valid-color);
	}

	:host(:hover) {
		position: relative;
	}

	:host([hidden]) {
		display: none;
	}

	:host([disabled]) {
		opacity: 0.2;
		pointer-events: none;
	}

	div {
		display: flex;
		align-items: flex-start;
		justify-content: center;
	}

	.icon {
		height: var(--icon-size);
		width: var(--icon-size);
		min-height: var(--icon-size);
		min-width: var(--icon-size);
		background: var(--icon-color) var(--icon-img) no-repeat center / contain;
		margin-inline-start: 0.3em;
		filter: var(--filter);
	}

	.label {
		font-size: var(--label-size);
		min-width: 3em;
		text-align: start;
	}

	:host(:hover) > * > .icon {
		filter: var(--hover-filter);
	}

	:host(:active) > * > .icon {
		filter: var(--actve-filter);
	}

	:host(:hover), :host(.willBeShown) {
		background: var(--pressed-bgcolor);
	}

	:host(:focus) {
		outline: var(--focus-outline);
		outline-offset: -2px;
	}

	:host(:active) > div {
		background: var(--pressed-bgcolor);
	}

	#close {
		position: absolute;
		right: 0; /* FIX RTL */
		background: radial-gradient(var(--bgcolor), transparent);
	}
`);
customElements.define("wsp-src-tab", SrcTab);


REG.reg.addToList("actions:itemViewerMulti", "pin", 1, new Action<SrcTab>("pin")
	.setIcon((ctx: SrcTab) => ctx.pinned ? "/@skin@/wsp/views/itemViewerMulti/unpin.svg" : "/@skin@/wsp/views/itemViewerMulti/pin.svg")
	.setLabel((ctx: SrcTab) => ctx.pinned ? "Libérer l'onglet" : "Figer l'onglet")
	.setGroup("tab")
	.setVisible((ctx: SrcTab) => !ctx.frozen)
	.setExecute((ctx: SrcTab, ev?: Event) => {
		ctx.pinned = !ctx.pinned;
	}));

const closeAction = new Action<SrcTab>("close")
	.setIcon("/@skin@/commons/icons/close.svg")
	.setLabel("Fermer")
	.setGroup("close")
	.setVisible((ctx: SrcTab) => !ctx.frozen)
	.setExecute((ctx: SrcTab, ev?: Event) => {
		if (ev) ev.stopPropagation(); //en btn dns le tab, block le select.
		ctx.parentViewCtn.closeTab(ctx);
	});
REG.reg.addToList("actions:itemViewerMulti", "close", 1, closeAction);

REG.reg.addToList("actions:itemViewerMulti", "closeAll", 1, new Action<SrcTab>("closeAll")
	//.setIcon("/@skin@/commons/icons/close.svg")
	.setLabel("Tout fermer")
	.setGroup("close")
	.setVisible((ctx: SrcTab) => !ctx.frozen)
	.setExecute((ctx: SrcTab, ev?: Event) => {
		if (ctx.pinned) {
			//Ferme tout, y compris pinned
			ctx.parentViewCtn.visitTabsAsync(async (t: Tab): Promise<any | 'stop'> => {
				if (t instanceof SrcTab && !t.frozen) if (!await t.parentViewCtn.closeTab(t)) return 'stop';
			});
		} else {
			//Ferme les onglets non pinned.
			ctx.parentViewCtn.visitTabsAsync(async (t: Tab): Promise<any | 'stop'> => {
				if (t instanceof SrcTab && !t.frozen && !t.pinned) if (!await t.parentViewCtn.closeTab(t)) return 'stop';
			});
		}
	}));

REG.reg.addToList("actions:itemViewerMulti", "closeOthers", 1, new Action<SrcTab>("closeOthers")
	//.setIcon("/@skin@/commons/icons/close.svg")
	.setLabel("Fermer les autres")
	.setGroup("close")
	.setVisible((ctx: SrcTab) => !ctx.frozen)
	.setExecute((ctx: SrcTab, ev?: Event) => {
		if (ctx.pinned) {
			//Ferme les autres, y compris pinned
			ctx.parentViewCtn.visitTabsAsync(async (t: Tab): Promise<any | 'stop'> => {
				if (t !== ctx && t instanceof SrcTab && !t.frozen) if (!await t.parentViewCtn.closeTab(t)) return 'stop';
			});
		} else {
			//Ferme les autres onglets non pinned.
			ctx.parentViewCtn.visitTabsAsync(async (t: Tab): Promise<any | 'stop'> => {
				if (t !== ctx && t instanceof SrcTab && !t.frozen && !t.pinned) if (!await t.parentViewCtn.closeTab(t)) return 'stop';
			});
		}
	}));

class OpenInTabs extends Action<SrcTab> {
	_id: 'left' | 'main' | 'right';

	constructor(pos: 'left' | 'main' | 'right', label: string) {
		super(pos);
		this._label = label;
		this._group = 'tab';
	}

	isVisible(ctx: SrcTab): boolean {
		return ctx.parentViewCtn.tabsPos !== this._id;
	}

	execute(ctx: SrcTab, ev?: Event): any | "noPreventDefault" {
		ctx.parentViewCtn.areasContext.openSrcRefInTabs(this._id, SRC.srcRef((ctx.area as SrcArea).shortDesc));
	}
}

REG.reg.addToList("actions:itemViewerMulti", "openLeft", 1, new OpenInTabs("left", "Répliquer à gauche"));
REG.reg.addToList("actions:itemViewerMulti", "openMain", 1, new OpenInTabs("main", "Répliquer au centre"));
REG.reg.addToList("actions:itemViewerMulti", "openRight", 1, new OpenInTabs("right", "Répliquer à droite"));


/**
 * Action d'affichage d'un src issue de l'histo dans un SrcTabs.
 */
class SrcOpenFromHisto extends Action<SrcTabs> implements ISrcMainCtx {

	reg: IReg<IItemTypeUiEnv>;
	shortDesc: JSrcFields;

	protected _subArea: IArea<ISrcMainCtx, SrcMain>;

	constructor(itemViewer: ItemViewerMulti, shortDesc: JSrcFields) {
		super(null);
		this.shortDesc = shortDesc;
		this.reg = itemViewer.getRegItemType(shortDesc.itModel);
		this._subArea = this.reg.env.itemType.getSrcMainArea(this);
	}

	getLabel(ctx: SrcTabs): string {
		return this._subArea.getLabel(this);
	}

	getIcon(ctx: SrcTabs): string {
		return this._subArea.getIcon(this);
	}

	getDescription(ctx: SrcTabs): string {
		return this._subArea.getDescription(this);
	}

	getGroup(ctx: SrcTabs): string {
		return this._subArea.getGroup(this);
	}

	isEnabled(ctx: SrcTabs): boolean {
		return this._subArea.isEnabled(this);
	}

	isVisible(ctx: SrcTabs): boolean {
		return this._subArea.isVisible(this);
	}

	execute(ctx: SrcTabs, ev?: Event): any | "noPreventDefault" {
		ctx.addTab(new SrcArea(ctx.areasContext, this.shortDesc), {select: true});
	}
}
